export enum Appearance {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  WHITE = 'white',
  NEUTRAL = 'neutral',
  DANGER = 'danger',
  INFO = 'info',
  WARNING = 'warning',
  SUCCESS = 'success',
  CASH = 'cash',
  PAYROLL = 'payroll',
}

export enum Size {
  SMALLEST = 'smallest',
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  LARGEST = 'largest',
}

export enum FontWeight {
  REGULAR = 400,
  MEDIUM = 500,
  SEMI_BOLD = 600,
  BOLD = 700,
}

export enum Direction {
  ROW = 'row',
  COLUMN = 'column',
}

export enum Align {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
  JUSTIFY = 'justify',
  START = 'start',
  END = 'end',
}
